import { PublicAccessCarTestDriveSectionDto } from '../types/models.types';
import { getRatingMessage } from '@/helpers/ratingState';
import { mapScoreToNumber, mapEquipmentStatusToBadge } from './mapper-helpers';
import { RatingSection } from './mapper-types';
import { InspectionItem } from '@/components/InspectionList/InspectionList.types';

export interface MappedTestDriveSection {
  ratingSection: RatingSection;
  remarks: string[];
  testDriveItems: InspectionItem[];
  expertSummary: string | null;
  drivenBy: string | null;
}

export const mapTestDriveSectionToUI = (
  section: PublicAccessCarTestDriveSectionDto | null | undefined,
): MappedTestDriveSection | null => {
  if (!section) {
    return null;
  }

  const summary = section.reportSectionSummary;
  const rating = mapScoreToNumber(summary?.score);
  const testDrive = section.carTestDriveSubsection;

  // Map test drive items
  const testDriveItems: InspectionItem[] = [
    {
      id: '1',
      name: 'Uruchomienie',
      status: mapEquipmentStatusToBadge(testDrive?.engineStart),
      badgeCustomText: testDrive?.engineStart,
      comments: testDrive?.engineStartRemark,
    },
    {
      id: '2',
      name: 'Kontrolki gaśną po uruchomieniu',
      status: mapEquipmentStatusToBadge(testDrive?.warningLightsOffAfterStart),
      badgeCustomText: testDrive?.warningLightsOffAfterStart,
      comments: testDrive?.warningLightsOffAfterStartRemark,
    },
    {
      id: '3',
      name: 'Kolor spalin',
      status: mapEquipmentStatusToBadge(testDrive?.exhaustColor),
      badgeCustomText: testDrive?.exhaustColor,
      comments: testDrive?.exhaustColorRemark,
    },
    {
      id: '4',
      name: 'Utrudnienia zmiany biegów',
      status: mapEquipmentStatusToBadge(testDrive?.gearShiftingDifficulties),
      badgeCustomText: testDrive?.gearShiftingDifficulties,
      comments: testDrive?.gearShiftingDifficultiesRemark,
    },
    {
      id: '5',
      name: 'Utrzymanie toru jazdy',
      status: mapEquipmentStatusToBadge(testDrive?.laneKeeping),
      badgeCustomText: testDrive?.laneKeeping,
      comments: testDrive?.laneKeepingRemark,
    },
    {
      id: '6',
      name: 'Tempomat',
      status: mapEquipmentStatusToBadge(testDrive?.cruiseControl),
      badgeCustomText: testDrive?.cruiseControl,
      comments: testDrive?.cruiseControlRemark,
    },
    {
      id: '7',
      name: 'Hamowanie',
      status: mapEquipmentStatusToBadge(testDrive?.braking),
      badgeCustomText: testDrive?.braking,
      comments: testDrive?.brakingRemark,
    },
    {
      id: '8',
      name: 'Przyspieszenie',
      status: mapEquipmentStatusToBadge(testDrive?.acceleration),
      badgeCustomText: testDrive?.acceleration,
      comments: testDrive?.accelerationRemark,
    },
    {
      id: '9',
      name: 'Luz na kierownicy',
      status: mapEquipmentStatusToBadge(testDrive?.steeringWheelPlay),
      badgeCustomText: testDrive?.steeringWheelPlay,
      comments: testDrive?.steeringWheelPlayRemark,
    },
    {
      id: '10',
      name: 'Zawieszenie',
      status: mapEquipmentStatusToBadge(testDrive?.suspension),
      badgeCustomText: testDrive?.suspension,
      comments: testDrive?.suspensionRemark,
    },
    {
      id: '11',
      name: 'Hamulec ręczny',
      status: mapEquipmentStatusToBadge(testDrive?.handBrake),
      badgeCustomText: testDrive?.handBrake,
      comments: testDrive?.handBrakeRemark,
    },
    {
      id: '12',
      name: 'Instalacja gazowa - przełączenie',
      status: mapEquipmentStatusToBadge(testDrive?.gasInstallationSwitch),
      badgeCustomText: testDrive?.gasInstallationSwitch,
      comments: testDrive?.gasInstallationSwitchRemark,
    },
  ];

  return {
    ratingSection: {
      title: 'Ocena jazdy próbnej',
      rating,
      ratingMessage: rating !== null ? getRatingMessage(rating) : 'Brak oceny',
      description: summary?.remarks && summary?.remarks?.length > 0 ? "Zwróć uwagę na podsumowanie wybranych zastrzeżeń dotyczących tej sekcji." : null,
      defectFree: summary?.defectFree ?? false,
    },
    remarks: summary?.remarks || [],
    testDriveItems,
    expertSummary: testDrive?.expertSummary || null,
    drivenBy: testDrive?.derivedBy || null,
  };
};
